module.exports = __webpack_public_path__ + "img/76040.bc612ec9.svg";